// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active[data-v-6c4d8baa]{color:#333!important}.footerbox[data-v-6c4d8baa]{position:relative;background:#fff;width:100%;height:13.333vw;color:#a3a3a3;font-size:2.933vw;position:fixed;bottom:0;left:0;z-index:1}.footerbox .footerboximg[data-v-6c4d8baa]{margin:2vw auto .667vw;width:5.333vw;height:5.333vw}", ""]);
// Exports
module.exports = exports;
